import Modal from './Modal'
import Crumbs from './Crump'
import MyPagination from './myPagination'
export default {
    install(app) {
        app.component(Modal.name,Modal)
        app.component(Crumbs.name,Crumbs)
        app.component(MyPagination.name,MyPagination)
    }
}